import { HttpClient, HttpContext, HttpHeaders, HttpParams } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { APIResponse } from "../models/common.models"
import { backend } from "../../environments/environment"
import { lastValueFrom } from "rxjs";
import { CookieService } from "ngx-cookie";


@Injectable({
    providedIn: 'root'
})
export class PDEHttpClient {

    constructor(
        private http: HttpClient,
        private cookies: CookieService
    ) {}
  

    get<T>(path: string, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        transferCache?: {
            includeHeaders?: string[];
        } | boolean;
    }): Promise<APIResponse<T>>{
        return lastValueFrom(this.http.get<APIResponse<T>>(backend + path, options))
    }

    authorizedGet<T>(path: string, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        transferCache?: {
            includeHeaders?: string[];
        } | boolean;
    }): Promise<APIResponse<T>>{
        let token = this.cookies.get("token")
        if(!token)
            window.location.reload()
        let auth = `Bearer ${token}`
        if(options){
            if(options["headers"])
                options["headers"]["Authorization"] = auth
            else
                options["headers"] = {"Authorization": auth}
        }
        else
            options = {"headers": {"Authorization": auth}}
        return lastValueFrom(this.http.get<APIResponse<T>>(backend + path, options)).then((response) => {
            this.cookies.put("token", response.token.value, {expires: new Date(response.token.expiry)})
            delete response.token
            return response
        })
    }

    post<T>(path: string, body: any | null, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        transferCache?: {
            includeHeaders?: string[];
        } | boolean;
    }): Promise<APIResponse<T>>{
        return lastValueFrom(this.http.post<APIResponse<T>>(backend + path, body, options))
    }

    authorizedPost<T>(path: string, body: any | null, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        transferCache?: {
            includeHeaders?: string[];
        } | boolean;
    }): Promise<APIResponse<T>>{
        let token = this.cookies.get("token")
        if(!token)
            window.location.reload()
        let auth = `Bearer ${token}`
        if(options){
            if(options["headers"])
                options["headers"]["Authorization"] = auth
            else
                options["headers"] = {"Authorization": auth}
        }
        else
            options = {"headers": {"Authorization": auth}}
        return lastValueFrom(this.http.post<APIResponse<T>>(backend + path, body, options)).then((response) => {
            this.cookies.put("token", response.token.value, {expires: new Date(response.token.expiry)})
            delete response.token
            return response
        })
    }

    authorizedDelete<T>(path: string, options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
        body?: any | null;
    }): Promise<APIResponse<T>>{
        let token = this.cookies.get("token")
        if(!token)
            window.location.reload()
        let auth = `Bearer ${token}`
        if(options){
            if(options["headers"])
                options["headers"]["Authorization"] = auth
            else
                options["headers"] = {"Authorization": auth}
        }
        else
            options = {"headers": {"Authorization": auth}}
        return lastValueFrom(this.http.delete<APIResponse<T>>(backend + path, options)).then((response) => {
            this.cookies.put("token", response.token.value, {expires: new Date(response.token.expiry)})
            delete response.token
            return response
        })
    }
  
    authorizedUpload(path: string, file: File){
        let token = this.cookies.get("token")
        if(!token)
            window.location.reload()
        let auth = `Bearer ${token}`
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(backend + path, formData, {
            headers: {"Authorization": auth},
            reportProgress: true,
            observe: 'events'
        })
    }

    authorizedDownload(path: string){
        let token = this.cookies.get("token")
        if(!token)
            window.location.reload()
        let auth = `Bearer ${token}`
        return this.http.get(backend + path, {
            headers: {"Authorization": auth},
            reportProgress: true,
            responseType: 'blob',
            observe: 'events'
        })
    }
  
}